import * as React from 'react';

import { FormSections, ProgramContainer } from '../entities/formTemplateDataType';

import { MenuComponent } from './MenuComponent';

import { FormPreviewComponent } from './FormPreviewComponent';
import { FormStepPreviewComponent } from './FormStepPreviewComponent';
import { FormDesignComponent } from './FormDesignComponent';
import { UploadComponent } from './UploadComponent';
import axios from 'axios';
import URLUtils from '../utilities/URLUtils';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import DataUtils from '../utilities/DataUtils';
import Utils from "../utilities/Utils";
import LoadingOverlay from 'react-loading-overlay';

import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js';
import LocalStorageService from '../services/SessionStorageService';
import { SummaryComponent } from '../runtimeComponent/subComponent/SummaryComponent';
// import { parseJson, stringifyJson } from '../utilities/JsonUtils';
import * as CircularJSON from 'circular-json';
import { TOKEN_TYPE } from '../entities/Constants';
import { js2xml } from 'xml-js';
import { isRuntime } from '../config';
//import { populateElementFindRoot } from '../utilities/ElementUtils';
import SessionStorageService from '../services/SessionStorageService';
import { provinceMap } from "../entities/Enums";
import SectionUtils from '../utilities/SectionUtils';
import { openHelpDocInNewTab } from '../utilities/HelpDocUtils';
import { deleteAnyNode } from '../utilities/JsonUtils';
import { isBxpForm } from '../utilities/ElementUtils';

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    // user: User,
    hash,
    callback: (programContainer: ProgramContainer) => void;
    callbackOriginalData;
    callbackUpdateOriginalData: (programContainer: ProgramContainer) => void;
}

interface State {
    // user: User;
    toggleState: {
        displayDesign: boolean;
        displayPreview: boolean;
        displayStepPreview: boolean;
        displayPublish: boolean;
        displaySave: boolean;
        displayDownload: boolean;
        displayUpload?: boolean;
        displayDownloadHelp?: boolean;
    },
    isEng: boolean,
    dialogVisible: boolean,
    orginalEntity,
    isBusy: boolean,
    hideValidationPanel: boolean,
    previewStepIndex: number,
}

export class DetailFormComponent extends React.Component<Props, State> {

    formSectionsList;
    programContainer;
    growl: Toast;
    errorMessages: string[] = [];
    validationErrorString: any = [];

    private normalizeEscapedParentheses = (pattern: string): string => {
        // Some stored patterns are over-escaped (e.g. "\\\\("), which breaks RegExp parsing.
        return pattern.replace(/\\\\([()])/g, '\\$1');
    };

    private validateRegexPatternsBeforeSave = (): { valid: boolean; message?: string } => {
        const sections = this.props.programContainer?.ListOfFormSections || [];

        for (const section of sections) {
            const sectionTitle = section?.ENUTitle || section?.FRATitle || section?.Id || 'Unknown section';
            const subSections = section?.ListOfFormSubSections || [];

            for (const subSection of subSections) {
                const subSectionTitle = subSection?.ENUTitle || subSection?.FRATitle || subSection?.Id || 'Unknown subsection';
                const elements = subSection?.ListOfFormSectionElements || [];

                for (const element of elements) {
                    const regexFields = [
                        { key: 'RegularExpression', label: 'Regular Expression' },
                        { key: 'licensePlateRegex', label: 'License Plate Regex' },
                    ];

                    for (const regexField of regexFields) {
                        const rawPattern = element?.[regexField.key];
                        if (typeof rawPattern !== 'string' || !rawPattern.trim()) {
                            continue;
                        }

                        const pattern = rawPattern.trim();
                        const normalizedPattern = this.normalizeEscapedParentheses(pattern);

                        try {
                            new RegExp(normalizedPattern);
                        } catch (error) {
                            const fieldLabel = element?.LoadBindName || element?.ENUTitle || element?.Datatype || element?.Id || 'Unknown field';
                            const errorMessage = error instanceof Error ? error.message : String(error);
                            const hint = pattern.includes('\\\\(')
                                ? ' Hint: remove one backslash before "(" (use "\\(" instead of "\\\\(").'
                                : '';

                            return {
                                valid: false,
                                message: `${regexField.label} is invalid in Section "${sectionTitle}" > Subsection "${subSectionTitle}" > Field "${fieldLabel}". Pattern: ${pattern}. Error: ${errorMessage}.${hint}`
                            };
                        }

                        if (normalizedPattern !== pattern) {
                            element[regexField.key] = normalizedPattern;
                        }
                    }
                }
            }
        }

        return { valid: true };
    };

    private applyServerMetadata = (programContainer: ProgramContainer, responseData: any): ProgramContainer => {
        if (!programContainer || !responseData) {
            return programContainer;
        }

        const nextId = responseData.id ?? programContainer.id;
        const nextVersion = responseData.version ?? programContainer.version;
        const nextCategoryId = responseData.categoryId ?? programContainer.CategoryId ?? programContainer['categoryId'];

        programContainer.id = nextId;
        programContainer.version = nextVersion;
        programContainer.CategoryId = nextCategoryId;
        programContainer['categoryId'] = nextCategoryId;

        return programContainer;
    };

    private syncCurrentContainerMetadata = (responseData: any) => {
        if (!this.props.programContainer) {
            return;
        }

        this.applyServerMetadata(this.props.programContainer, responseData);
    };

    constructor(props: Props) {
        super(props);
         //populateElementFindRoot(this.props.programContainer);
        let programContainer = this.props.programContainer

        if (this.props.programContainer == null) {
            programContainer = new ProgramContainer();
            this.formSectionsList = new Array<FormSections>();
            programContainer.ListOfFormSections = this.formSectionsList;
        }
        this.state = {
            // user: this.props.user,
            orginalEntity: {},
            toggleState: {
                displayDesign: true,
                displayPreview: false,
                displayStepPreview: false,
                displayPublish: false,
                displaySave: false,
                displayDownload: false
            },
            isEng: true,
            dialogVisible: false,
            isBusy: false,
            hideValidationPanel: true,
            previewStepIndex: 0,
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.programContainer !== this.props.programContainer) {
            this.setState({
                previewStepIndex: 0,
                toggleState: {
                    displayDesign: true,
                    displayPreview: false,
                    displayStepPreview: false,
                    displayPublish: false,
                    displaySave: false,
                    displayDownload: false
                }
            });
        }
    }

    getProgramFromAPI = () => {
        const categoryId = this.props.programContainer?.CategoryId?.toLowerCase();
        console.log('getProgramFromAPI called with categoryId:', categoryId);
        if (Utils.isNullOrEmpty(categoryId)) {
            return
        }
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        const url = "data/admin/get/" + categoryId.toLowerCase();
        const urlFull = URLUtils.concatUrls(url);
        axios.get(urlFull, { headers: headers }).then((response) => {

            const latestProgramContainer = this.applyServerMetadata(
                CircularJSON.parse(response.data.attachment) as ProgramContainer,
                response.data
            );
            this.props.programContainer.ListOfFormSections = latestProgramContainer.ListOfFormSections;
            this.syncCurrentContainerMetadata(response.data);
            this.props.callback(this.props.programContainer);
    });
        console.log('programContainer.ListOfFormSections: ', this.props.programContainer.ListOfFormSections);
        
    }

    reloadFormAfterConflict = () => {
        const categoryId = this.props.programContainer?.CategoryId?.toLowerCase();
        if (Utils.isNullOrEmpty(categoryId)) {
            return;
        }
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        if (!token) return;
        const headers = { 'Authorization': `Bearer ${token}` };

        const url = "data/admin/get/" + categoryId;
        const urlFull = URLUtils.concatUrls(url);
        axios.get(urlFull, { headers: headers }).then((response) => {
            let programContainer = this.applyServerMetadata(
                CircularJSON.parse(response.data.attachment) as ProgramContainer,
                response.data
            );
            this.syncCurrentContainerMetadata(response.data);
            this.props.callback(programContainer);
            this.props.callbackUpdateOriginalData(programContainer);
            this.growl.show({ severity: 'info', summary: 'Reloaded', detail: 'Form reloaded with the latest version. Please re-apply your changes and save again.' });
        }).catch(() => {
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'Failed to reload the form. Please refresh the page.' });
        });
    }
    // componentDidUpdate(prevProps, prevState) {
    //     if (
    //         !prevState.toggleState.displayDesign &&
    //         this.state.toggleState.displayDesign
    //     ) {
    //         this.getProgramFromAPI();
    //     }
    // }
    
    render() {
        
        let htmlString = [];
        htmlString.push(
            <div style={{ display: 'flex', justifyContent: 'flex-space' }}>
                <div>
                    <MenuComponent
                        callback={(state) => {
                            if(state.displayPreview || state.displayStepPreview){
                                SectionUtils.initProgramContainer(this.props.programContainer);
                                this.props.callback(this.props.programContainer);
                                this.setState({ toggleState: state, isEng: this.state.isEng });
                            }
                            if (state.displayDownload) {
                                this.download();
                            } else if (state.displayDownloadPayload) {
                                this.downloadPayload();
                            } else if (state.displayDownloadPDF) {
                                this.downloadPDF();
                            } else if (state.displayDownloadXML) {
                                this.downloadXML();
                            } else if (state.displayDownloadHelp) {
                                this.downloadHelpDoc();
                            }
                            else if (state.displayUpload) {
                                let toggleState = {
                                    displayDesign: false,
                                    displayPreview: false,
                                    displayStepPreview: false,
                                    displayPublish: false,
                                    displaySave: false,
                                    displayDownload: false,
                                    displayUpload: true,
                                };

                                this.setState({ toggleState: toggleState })
                            } else if (state.displaySave && !this.state.toggleState.displayPreview) {
                                const userId = LocalStorageService.getUserId().toLowerCase();
                                const isCoowner = this.props.programContainer.Coowners?.filter(coowner => coowner.email.toLowerCase() == userId)?.length > 0;

                                if (isCoowner || !this.props.programContainer.createdBy || this.props.programContainer.createdBy?.toLowerCase() == userId) {
                                    this.saveLayout();
                                }
                                else if (this.props.programContainer.Deployed) {
                                    this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'The form has been deployed to production thus it is not allowed to be changed by the users other than the creator' });
                                } else {
                                    let api = URLUtils.concatUrls('data/admin/form/' + this.props.programContainer.id);
                                    const token = LocalStorageService.getAccessToken(TOKEN_TYPE.API);
                                    const headers = {
                                        'Authorization': `Bearer ${token}`
                                    }
                                    axios.get(api, { headers: headers })
                                        .then((response) => {
                                            let coowners = CircularJSON.parse(response.data.attachment).Coowners;
                                            let userIsCoowners = coowners && coowners.length > 0 && coowners.reduce((acc, user) => acc || (userId.toLowerCase() == String(user.userName).toLowerCase()), false);
                                            if (userIsCoowners) { this.saveLayout() }
                                            else {
                                                this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'You do not have permission to change this form' });
                                            }
                                        })
                                        .catch((message) => {
                                            console.log(message);
                                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Save failed' });
                                        });
                                }

                            } else if (state.displaySubmit) {
                                this.saveSubmit();
                            } else if (state.displayDesign) {
                                this.setState({
                                    toggleState: state,
                                    dialogVisible: false,
                                    isEng: this.state.isEng
                                }, () => {
                                    //  this.getProgramFromAPI();
                                    //this.props.callback(this.props.programContainer);
                                    if (this.props.programContainer.IsDirty) {
                                        //if (window.confirm(`Form need to reload due to changes at preview. Are you sure you want to continue?`)) {
                                            this.props.callbackOriginalData(this.props.programContainer);
                                        //}
                                    }
                                });

                            } else {
                                this.setState({ toggleState: state });
                            }
                        }}></MenuComponent>
                </div>

                {this.state.toggleState.displayUpload&&(<div style={{ display:  'block', width: '80%' }}>
                    <UploadComponent
                        programContainer={this.props.programContainer}
                        callback={(programContainer) => {
                            this.props.callback(programContainer);
                        }} />
                </div>)}

                {this.state.toggleState.displayDesign&&(<div style={{ display: 'block', width: '80%' }}>
                    <FormDesignComponent
                        isEng={this.state.isEng}
                        programContainer={this.props.programContainer}
                        dialogVisible={this.state.dialogVisible}
                        callback={programContainer => this.props.callback(programContainer)}
                        callBackLang={isEng => this.setState({ isEng: isEng })}
                        callbackSave={() => this.saveLayout()}
                    />
                </div>)}

                {this.state.toggleState.displayPreview &&(<div style={{ display: 'block', width: '80%' }}>
                    {!this.state.hideValidationPanel && this.validationErrorString}
                    <FormPreviewComponent
                        isEng={this.state.isEng}
                        hash={this.props.hash}
                        programContainer={this.props.programContainer}
                        callbackOriginalData={orginalEntity => { this.setState({ orginalEntity: orginalEntity }) }}
                        callback={para => this.props.callback(para)}
                        callBackLang={isEng => this.setState({ isEng: isEng })} />
                </div>)}

                {this.state.toggleState.displayStepPreview &&(<div style={{ display: 'block', width: '80%' }}>
                    {!this.state.hideValidationPanel && this.validationErrorString}
                    {this.renderStepPreview()}
                </div>)}
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} >
                        <LoadingOverlay active={this.state.isBusy} overlayColor="rgba(0,153,255,0.2)" />
                    </div>
                </div>
            </div>

        )

        htmlString.push(
            <>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
            </>
        )
        return htmlString;
    }

    renderStepPreview = () => {
        if (!this.props.programContainer || !this.props.programContainer.ListOfFormSections) {
            return (
                <div style={{ 
                    padding: '20px', 
                    textAlign: 'center', 
                    color: '#666',
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    backgroundColor: '#f9f9f9'
                }}>
                    <h4>No Form Data Available</h4>
                    <p>Please create or load a form first before previewing steps.</p>
                </div>
            );
        }

        const sections = this.props.programContainer.ListOfFormSections || [];
        
        console.log('renderStepPreview called, current step:', this.state.previewStepIndex);
        console.log('Available sections:', sections.map(s => s.ENUTitle));
        
        return (
            <div>
                <div className="step-selector-controls" style={{ 
                    marginBottom: '20px', 
                    padding: '15px', 
                    backgroundColor: '#f5f5f5', 
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <h4 style={{ margin: '0 0 15px 0', color: '#333' }}>Select Step to Preview:</h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {sections.map((section, index) => (
                            <Button
                                key={index}
                                label={`Step ${index + 1}: ${this.state.isEng ? section.ENUTitle : section.FRATitle}`}
                                className={this.state.previewStepIndex === index ? 'p-button-info' : 'p-button-outlined'}
                                onClick={() => {
                                    console.log(`Selecting step ${index}: ${section.ENUTitle}`);
                                    this.setState({ previewStepIndex: index });
                                }}
                                style={{ 
                                    minWidth: '150px',
                                    fontSize: '13px'
                                }}
                            />
                        ))}
                    </div>
                </div>
                
                <div>
                    <FormStepPreviewComponent
                        programContainer={this.props.programContainer}
                        stepIndex={this.state.previewStepIndex}
                        isEng={this.state.isEng}
                        callBackLang={(isEng) => this.setState({ isEng })}
                        onBusyChange={(isBusy) => this.setState({ isBusy })}
                        callback={(programContainer) => this.props.callback(programContainer)}
                    />
                </div>
            </div>
        );
    };


    saveLayout = () => {
        if (this.state.isBusy) {
            return;
        }

        const missing: string[] = [];
        if (Utils.isNullOrEmpty(this.props.programContainer.CategoryId)) missing.push("Application ID");
        const appName = this.state.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA;
        if (Utils.isNullOrEmpty(appName)) missing.push("Application Name");
        if (Utils.isNullOrEmpty(this.props.programContainer.Hosted)) missing.push("Host");
        if (missing.length) {
            this.growl.show({ severity: 'error', summary: 'Missing required fields', detail: `Please enter: ${missing.join(', ')}` });
            return;
        }
        console.log('props.programContainer before save:', this.props.programContainer);
        if (this.props.programContainer.IsDirty) {
            alert('Cannot save due to the layout has changed by preview. Click Design to reload the form.')
            return;
        } 
        if(isBxpForm(this.props.programContainer.CategoryId) && !this.validateLayout()) return;

        const regexValidation = this.validateRegexPatternsBeforeSave();
        if (!regexValidation.valid) {
            this.growl.show({ severity: 'error', summary: 'Invalid regex in form layout', detail: regexValidation.message });
            return;
        }

 

        let api = "data/admin/save";
        let entity;
        this.setState({ isBusy: true });
        if (isRuntime()==='false') {
            
            let programContainer =  DataUtils.clearFormValue(this.props.programContainer);
            programContainer = deleteAnyNode('orginalClone', programContainer);
            programContainer = deleteAnyNode('originalElements', programContainer);
            console.log(programContainer)
            let content = CircularJSON.stringify(programContainer);
            entity = {
                id: this.props.programContainer.id,
                categoryName: this.props.programContainer.Name,
                formType: 'Form',
                attachment: content,
                categoryId: this.props.programContainer.CategoryId,
                version: this.props.programContainer.version
            }
        } else {
            let caseId = this.props.hash.match("(?<=&caseId\=)(.*)");
            api = "data/case/save";
            let values = DataUtils.collectFormValue(this.props.programContainer);

            entity = {
                caseId: caseId[0],
                id: this.props.programContainer.id,
                formValue: values,
            }
        }

        // let userToken = LocalStorageService.getAccessToken();

        // if (process.env.ENV == 'local') {
        //     axios.post(URLUtils.concatUrls(api), entity, { withCredentials: true })                .then((result) => {
        //             this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form saved' });
        //             this.setState({ isBusy: false });
        //             let programContainer = CircularJSON.parse(result.data.attachment);
        //             programContainer.id = result.data.id;
        //             this.props.callback(programContainer);
        //         }
        //         )
        // } else {
        let token = LocalStorageService.getAccessToken(TOKEN_TYPE.API);
        if (!token) {
            this.growl.show({ severity: 'error', summary: 'Please refresh the application', detail: "Too long inactivity" });
            return;
        }
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        axios.post(URLUtils.concatUrls(api), entity, { headers: headers })
            .then((result) => {
                this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form saved' });
                this.setState({ isBusy: false });
                this.syncCurrentContainerMetadata(result.data);
                let programContainer = this.applyServerMetadata(
                    CircularJSON.parse(result.data.attachment) as ProgramContainer,
                    result.data
                );
                //populateElementFindRoot(programContainer);
                console.log(programContainer);
                this.props.callback(programContainer);
                this.props.callbackUpdateOriginalData(programContainer);
            })
            .catch((error) => {
                console.log(error);
                this.setState({ isBusy: false });
                const status = error.response?.status;
                const resBody = error.response?.data;
                if (status === 409) {
                    this.growl.show({ severity: 'error', summary: 'Version Conflict', detail: 'This form was modified by another user. Reloading the latest version...' });
                    this.reloadFormAfterConflict();
                } else if (resBody?.message == "Data input is not valid") {
                    for (const e of resBody.errors) {
                        this.growl.show({ severity: 'error', summary: 'Error Message', detail: e.split(':')[1] });
                    }
                } else if (resBody?.errors) {
                    for (const e of resBody.errors) {
                        if (e.includes("UC_Category_id")) {
                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Application ID must be unique' });
                        } else {
                            this.growl.show({ severity: 'error', summary: 'Error Message', detail: e });
                        }
                    }
                } else {
                    this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'An unexpected error occurred while saving.' });
                }
            })
        // }
    }

    validateLayout = (): boolean => {
        const map = new Map<string, string>();
    
        for (const formSection of this.props.programContainer.ListOfFormSections) {
            for (const subSection of formSection.ListOfFormSubSections) {
                for (const ele of subSection.ListOfFormSectionElements) {
    
                    if (ele.Datatype === 'Row' && ele.subSectionList?.length > 0) {
                        for (const el of ele.subSectionList[0].ListOfFormSectionElements) {
                            if (typeof el.LoadBindName === 'string') {
                                const elestr = `${formSection.ENUTitle}(Sequence ${formSection.Sequence}) > ` +
                                               `${subSection.ENUTitle}(Sequence ${subSection.Sequence}) > ` +
                                               `${el.ENUTitle}(Sequence ${el.Sequence})`;
    
                                if (map.has(el.LoadBindName)) {
                                    if (window.confirm(`Duplicate LoadBindName found:\n\n${map.get(ele.LoadBindName)}\n\n${elestr} \n\n Are you sure you want to continue?`)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                                if(ele.LoadBindName.trim().length>0){
                                    map.set(el.LoadBindName, elestr);
                                }
                            }
                        }
                    } else if (typeof ele.LoadBindName === 'string') {

                        const elestr = `${formSection.ENUTitle}(Sequence ${formSection.Sequence}) > ` +
                                       `${subSection.ENUTitle}(Sequence ${subSection.Sequence}) > ` +
                                       `${ele.ENUTitle}(Sequence ${ele.Sequence})`;
                        if (map.has(ele.LoadBindName)) {
                           if (window.confirm(`Duplicate LoadBindName found:\n\n${map.get(ele.LoadBindName)}\n\n${elestr} \n\n Are you sure you want to continue?`)) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        if(ele.LoadBindName.trim().length>0){
                            map.set(ele.LoadBindName, elestr);
                        }
                    }
                }
            }
        }
    
        return true;
    }
    


    saveSubmit = () => {
        let hash = this.props.hash;
        if (hash == null || hash == '') return null;
        let categoryId;

        let pattern = /categoryId=([^&]+)&caseId=([^&]+)/;
        if (hash.indexOf('language') > -1) {
            pattern = /categoryId=([^&]+)&caseId=([^&]+)&language=([^&]+)/;
        }
        const matches = hash.match(pattern);
        let caseId;
        if (matches) {
            caseId = matches[2];
        }
        if (caseId) {
            let api = this.props.programContainer.UpdateAPI;
            let caseObject = DataUtils.collectFormValue(this.props.programContainer, 'Y');
            caseObject["operation"] = "upsert";
            caseObject["Id"] = caseId;
            // caseObject["Id"] = this.state.orginalEntity.SiebelMessage.HLSCase.Id;
            let containerName = "ListOf" + this.props.programContainer.IntObjectName;
            let SiebelObject = {
                "SiebelMessage": {
                    "MessageId": this.state.orginalEntity.SiebelMessage.MessageId,
                    "MessageType": this.state.orginalEntity.SiebelMessage.MessageType,
                    "IntObjectName": this.props.programContainer.IntObjectName,
                    "IntObjectFormat": this.state.orginalEntity.SiebelMessage.IntObjectFormat,
                }
            };

            SiebelObject.SiebelMessage[containerName] = {
                "HLSCase": caseObject
            }

            let fullApiUrl = URLUtils.concatUrls("data/tpon/transfer");
            let body = { "body": SiebelObject }
            let transferUrl = this.props.programContainer.APIBasePath + api;
            let httpMethod = "POST";
            let tponTransferDto = { httpMethod: httpMethod, url: transferUrl, payload: body }

            // let script = "this.errorMessages.push('Hi');"
            // eval(script);
            //get all Scripts to execute
            //   this.executeValidationScript();
            //all script generated errors are pushed to this.errorMessages
            if (this.errorMessages.length == 0) {
                this.setState({ isBusy: true });
                axios.post(fullApiUrl, tponTransferDto, { withCredentials: true })
                    .then((response) => {
                        this.setState({ isBusy: false });
                        this.growl.show({ severity: 'success', summary: 'Success Message', detail: 'Form submitted successfully' });
                        //return always has SiebelMessage.HLSCase to begin with 
                        // DataUtils.assignFormValue(this.programContainer, response.data.SiebelMessage.HLSCase);
                    })
            }
        }
    }

    //Download pdf html2pdf version
    downloadPDF = async () => {
        const pdfJSX = () => {
            return (
                <div style={{ display: "block : none", margin: "25px 15px" }}>
                    {<SummaryComponent programContainer={this.programContainer} isEng={this.props.isEng}></SummaryComponent>}
                </div>
            )
        }
        const printElement = ReactDOMServer.renderToString(pdfJSX());
        const pdf = await html2pdf().set({ margin: [20, 10, 20, 10] }).from(printElement).toPdf().get('pdf');
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const totalPages = pdf.internal.getNumberOfPages();
        const timestamp = new Date().toLocaleString();
        const copyright = "© King's Printer for Ontario, 26";

        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.text(copyright, 10, height - 10, { align: 'left' });
            pdf.text(timestamp, width - 10, height - 10, { align: 'right' });
        }

        pdf.save("summaryPdf.pdf");
    }

    download = () => {

        if (this.props.programContainer.IsDirty) {
            alert('Cannot download due to the layout has changed by preview. Click Design to reload the form.')
            return;
        } 

        if(isBxpForm(this.props.programContainer.CategoryId) && !this.validateLayout()) return;
        let contentCloned: ProgramContainer = CircularJSON.parse(CircularJSON.stringify(this.props.programContainer));
        contentCloned = deleteAnyNode('orginalClone', contentCloned);
        contentCloned = deleteAnyNode('originalElements', contentCloned);
        delete contentCloned.version;
        contentCloned.ListOfFormSections.forEach(section => {
            (section as any).parent = "~";
            section.ListOfFormSubSections.forEach(subSection => {
                subSection.ListOfFormSectionElements.forEach(ele => {
                    if (ele.Datatype != 'Label' && ele.Datatype != 'TechError' && ele.Datatype != "HTML") 
                        ele.Value = null;
                    ele.day = null;
                    ele.month = null;
                    ele.year = null;
                })
            })
        })
        contentCloned.Entity = null;
        contentCloned.createdById = "";
        // contentCloned.Coowners = [];
        let content = CircularJSON.stringify(contentCloned, null, 2);
        content = content.replace(/"parent"\s*:\s*"\\\\x7e"/g, '"parent": "~"');

        const blob = new Blob([content], { type: `application/json;charset=utf-8;` });
        const link = document.createElement('a');
        const layoutFileName = `${this.props.programContainer?.CategoryId || 'configForm'}.json`;
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', layoutFileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    

    downloadPayload = () => {
        if(isBxpForm(this.props.programContainer.CategoryId) && !this.validateLayout()) return;
        let payload = DataUtils.collectFormValue(this.props.programContainer);

        let outputData = CircularJSON.stringify(payload);

        const blob = new Blob([outputData], { type: `application/json;charset=utf-8;` });
        const link = document.createElement('a');
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'payload.json');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    // Generate xml string
    static generateXML = (payload) => {
        console.log('download xml file');
        delete payload.Error;
        const options = { compact: true, ignoreComment: true, spaces: 0 };
 
        // Perform address field separation if field name is address or ends with .address
        replaceAddressFields(payload);
        replaceFileFields(payload);
        const xmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
        const versionNo = '<versionNo>1.0</versionNo>';
        let bodyXml = js2xml(payload, options);
        bodyXml = bodyXml.replace(/<importantNotice>/g, '<importantNotice><specify/>');
        const outputData = `${xmlHeader}<form1>${versionNo}` + bodyXml + '<systemDate>' + Utils.getFormattedDateYYYYMMDD(new Date()) + '</systemDate></form1>';
        return outputData;
    }
 
    downloadXML = () => {
        const payload = DataUtils.collectFormValue(this.props.programContainer);
        const outputData = DetailFormComponent.generateXML(payload);
        const blob = new Blob([outputData], { type: `application/xml;charset=utf-8;` });
        const link = document.createElement('a');
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'payload.xml');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    downloadHelpDoc = () => {
        openHelpDocInNewTab("Help");
    }
}
 
const replaceAddressFields = (obj) => {
    if (!obj) return;
   
    if (Array.isArray(obj)) {
        obj.forEach(replaceAddressFields);
        return;
    }
 
    for (const key of Object.keys(obj)) {
        const value = obj[key];

        if (typeof key === 'string' && key.toLowerCase() === 'address' && typeof value === 'string') {
            const parsed = parseAddress(value, Boolean(JSON.parse(obj.address_StringObject).isNoStreetNoAddress));
            delete obj[key];
            Object.assign(obj, parsed);
        } else if (typeof value === 'object' && value !== null) {
            replaceAddressFields(value);
        }

        /*
        if (typeof key === 'string' && key.toLowerCase() === 'address' && typeof value === 'string') {
            const parsed = parseAddress(value);
            obj[key] = parsed;
        } else if (typeof value === 'object' && value !== null) {
            replaceAddressFields(value);
        }
        */
    }
}
 
const parseAddress = (address, isNoStreet) => {
    // Assuming address is formatted: street, city, province, postal code
    const parts = address.split(',').map(part => part.trim());
   
    // Not enough parts
    if (parts.length < 3) {
        console.log('not enough parts');
        return {
            street1: address,
            street2: '',
            city: '',
            province: '',
            postalCode: '',
            country: ''
        };
    }

    const noStreetNoNumberFactor = isNoStreet?1:0;
 
    // Get city, province, postal code
    const city = parts[parts.length - 4 + noStreetNoNumberFactor];
    const province = parts[parts.length - 3+ noStreetNoNumberFactor];
    const provinceName = provinceMap[province.toUpperCase()] || province;
    const postalCode = parts[parts.length - 2+ noStreetNoNumberFactor];
 
    const streetRaw = parts.slice(0, parts.length - 4+ noStreetNoNumberFactor).join(', ');
 
    // Check for unit type
    const unitPattern = /^(APT|UNIT|SUITE|#)\s*[\w,]+/i;
    let street1 = streetRaw;
    let street2 = '';
 
    const unitMatch = streetRaw.match(unitPattern);

    if (unitMatch){
        const addressSplit = streetRaw.split(',').map(part => part.trim());
        if(addressSplit.length>2){
            street1 = addressSplit.splice(0,addressSplit.length-1).join(',');
            street2 = addressSplit[addressSplit.length-1];
        }
    }else if (!isNoStreet){
        const addressSplit = streetRaw.split(',');
        if(addressSplit.length>1){
            street1 = addressSplit.splice(0,addressSplit.length-1).join(', ');
            street2 = addressSplit[addressSplit.length-1];
        }
    }
 
        return {
            street1,
            street2,
            city,
            province: provinceName || province,
            postalCode,
            country: 'Canada'
        };
    }
 
const replaceFileFields = (obj) => {
    if (!obj) return;
 
    console.log('replaceFileFields');
    if (Array.isArray(obj)) {
        obj.forEach(replaceFileFields);
        return;
    }
 
    for (const key of Object.keys(obj)) {
        const value = obj[key];
 
        if ( Array.isArray(value) &&
                value.every(item => item &&
                typeof item == 'object' &&
                'attachment' in item && typeof item.attachment == 'string' &&
                'path' in item && typeof item.path == 'string'
            )) {
            const parsed = parseFiles(value, key);
            delete obj[key];
            Object.assign(obj, parsed);
        } else if (typeof value === 'object' && value !== null) {
            replaceFileFields(value);
        }
    }
}
 
const parseFiles = (files, key) => {
    const result = {
        [key]: {
            files: files.map(file => ({
                fileName: file.path,
                fileSize: (file.size / (1024 * 1024)).toFixed(2) // in MB
            }))
        }
    }
    console.log(result);
    return result;
}
